import React from 'react';
import { useState, useEffect } from 'react' 
import { Link } from 'react-router-dom';
import { db } from '../../../../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore';

const PHP = ({portfolioData}) => {   
    return (
        <>
            <div className="page-hd clearfix">
                <div className="left-float" style={{marginTop: "0px", marginRight: "20px"}}>
                    <img src="/images/skin1/php-logo.png" /> 
                </div>
                <div className="left-float" style={{marginTop: "10px"}}>
                    <p><strong>Experience: 3 Years</strong></p>
                    <p><strong></strong></p>
                </div>
            </div>
                <ul>
                <li>- Good understanding on custom PHP programming.</li>
                <li>- Experienced in working on PHP based frameworks like Laravel, CakePHP</li>
                <li>- Created my own MVC framework in PHP for internal projects.</li> 
            </ul>
            <h3>PHP Projects</h3><hr />
            <ul>
                <li><a href="https://clcd.com">CLCD</a></li>
                <li><a href="https://quickfind.clcd.com">QuickFindK-12</a></li>
            </ul>
             
        </>
        
    )

}
export default PHP;